import controllers from '@/store/controllers/controllers';
import { Dispatch } from 'vuex';
import limboControllers from '@/store/controllers/limboControllers';

export default {
	namespaced: true,
	modules: {
		controllers,
		limboControllers,
	},
	actions: {
		async fetchAllControllers({ dispatch }: { dispatch: Dispatch }): Promise<void> {
			await dispatch('controllers/fetchControllers');
		},

		cleanAllControllers({ dispatch }: { dispatch: Dispatch }): void {
			dispatch('controllers/cleanControllers');
			dispatch('limboControllers/cleanLimboControllers');
		},
	},
};
